module.exports = __webpack_public_path__ + "static/silver_dragon-f03ba573b4b976b1d4bf4bcf48146ea3.jpg";